/** Checks if currently in browser */
var inBrowser = function inBrowser() {
  return typeof window !== "undefined";
};
/** Opens a url in a new tab */


var openNewTab = function openNewTab(url) {
  var win = window.open(url);
  win === null || win === void 0 ? void 0 : win.focus();
};
/** Navigates to url */


var navigateOut = function navigateOut(url) {
  window.location.href = url;
};
/** Downloads a file with given filename an text content */


var download = function download(filename, text) {
  var element = document.createElement("a");
  element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export { download, inBrowser, navigateOut, openNewTab };